import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

type Props = {
  colorTag?: string
  colorText?: string
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '75%',
    flexGrow: 1
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette?.secondary.contrastText,
    marginBottom: 10
  },
  img: {
    /* width: '456px', */
    width: '100%',
    overflow: 'hidden',
    display: 'block',
    borderRadius: 5
  },
  stepers: {
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette?.secondary.light
  },
  buttons: {
    color: theme.palette?.secondary.contrastText
  },
  description: {
    color: 'white',
    width: '70%'
  },
  footerCarrusel: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 20,
    width: '100%',
    justifyContent: 'space-between'
  },
  tag: (props?: Props) => ({
    background: props?.colorTag,
    color: `${props?.colorText || theme.palette.grey[50]} !important`,
    borderRadius: '2px',
    padding: 8,
    fontStyle: 'normal',
    fontSize: 12,
    fontWeight: 900,
    lineHeight: '12px',
    letterSpacing: 1,
    textTransform: 'uppercase',
    gap: '4px'
  })
}))

export default useStyles
